module.exports = "/integrations/components/integrationStatus-9a8d31.html";